import { render, staticRenderFns } from "./LoginTitle.vue?vue&type=template&id=283f5754&scoped=true&"
import script from "./LoginTitle.vue?vue&type=script&lang=ts&"
export * from "./LoginTitle.vue?vue&type=script&lang=ts&"
import style0 from "./LoginTitle.vue?vue&type=style&index=0&id=283f5754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283f5754",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VRow})
